import { render, staticRenderFns } from "./ReportTransaction.vue?vue&type=template&id=5b5dc672&"
import script from "./ReportTransaction.vue?vue&type=script&lang=js&"
export * from "./ReportTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports